/**
 * Shopify Product Shipping Calculator
 * 
 * Este script calcula opções de frete para produtos na página de produto.
 * Usa uma abordagem com cookie temporário para calcular frete sem adicionar produtos ao carrinho real.
 */
(function() {
	"use strict";
	
	// Constantes e variáveis de configuração
	const DEBUG = false;
	
	// SVGs utilizados
	const ICON_BUTTON = `<svg aria-hidden="true" role="img" aria-labelledby="shipping-button" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
	  <title id="shipping-button">Calcular frete</title>
	  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
	</svg>`;
	
	const SPINNER_SVG = `<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
	  <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
	</svg>`;
	
	// Elementos DOM e variáveis de estado
	let cartCookie;
	let shippingCountry;
	let shippingProvince;
	
	// Inicialização quando o DOM estiver pronto
	document.addEventListener('DOMContentLoaded', init);
	
	/**
	 * Função principal de inicialização
	 */
	function init() {
	  // Verificar se o calculador já existe na página
	  const shippingCalcExist = document.querySelector(".shipping-calc-wrapper");
	  if (!shippingCalcExist) {
		log("Calculador de frete não encontrado na página");
		return;
	  }
	  
	  // Verificar se estamos na página de produto
	  const productSelect = document.querySelector('.product-form form input[name="id"]');
	  if (!productSelect) {
		log("Não foi possível encontrar o seletor de variante do produto");
		return;
	  }
	  
	  // Obter preço do produto
	  const productPriceElement = document.querySelector("product-data .c-product__details .c-product__prices .c-product__price");
	  const productPrice = productPriceElement 
		? productPriceElement.textContent.replace("R$", "").replace(",", ".").trim()
		: "0";
	  
	  // Inicializar os campos
	  setupFields(productSelect, productPrice);
	}
	
	/**
	 * Configura os campos e eventos do calculador
	 */
	function setupFields(productSelect, productPrice) {
	  // Criar elementos hidden para país e província
	  shippingCountry = document.createElement("select");
	  shippingProvince = document.createElement("select");
	  
	  // Configurar país (Brasil)
	  const countries = ["Brazil"];
	  for (let i = 0; i < countries.length; i++) {
		shippingCountry.add(new Option(countries[i], countries[i], i === 0));
	  }
	  shippingCountry.name = "shipping_address[country]";
	  shippingCountry.style.display = "none";
	  document.querySelector(".shipping-calc-wrapper").appendChild(shippingCountry);
	  
	  // Configurar província/estado (padrão: Acre)
	  const provinces = ["Acre"];
	  for (let i = 0; i < provinces.length; i++) {
		shippingProvince.add(new Option(provinces[i], provinces[i], i === 0));
	  }
	  shippingProvince.name = "shipping_address[province]";
	  shippingProvince.style.display = "none";
	  document.querySelector(".shipping-calc-wrapper").appendChild(shippingProvince);
	  
	  // Pegar referências para elementos UI
	  const shippingZip = document.querySelector("#shipping-calculator-input");
	  const shippingCalcButton = document.querySelector(".shippingCalcButton");
	  const shippingMessage = document.querySelector(".shipping-calc-wrapper .message");
	  
	  // Adicionar evento ao botão
	  shippingCalcButton.addEventListener("click", function(event) {
		event.preventDefault();
		
		// Limpar mensagens anteriores
		shippingMessage.innerHTML = "";
		shippingMessage.className = "message";
		
		// Verificar se variante está selecionada
		if (!productSelect.value.length) {
		  shippingMessage.className = "message error";
		  shippingMessage.innerHTML = "Por favor, selecione uma variante do produto.";
		  return false;
		}
		
		// Verificar se CEP foi preenchido
		if (!shippingZip.value.trim()) {
		  shippingMessage.className = "message error";
		  shippingMessage.innerHTML = "Por favor, informe seu CEP.";
		  return false;
		}
		
		// Mostrar spinner de carregamento
		shippingCalcButton.toggleAttribute("loading", true);
		shippingCalcButton.setAttribute("disabled", true);
		
		// Manipular cookie de carrinho para cálculo
		handleCartCookie();
		
		// Calcular taxas de frete
		calculateShippingRates(parseInt(productSelect.value), productPrice);
		
		return false;
	  });

	  	shippingZip.addEventListener('keydown', function (event) {
			if (event.key === 'Enter') {
			event.preventDefault();
			shippingCalcButton.click();
			}
		});
		shippingZip.addEventListener('input', function () {
			this.value = this.value.replace(/\D/g, '');
			this.value = this.value.slice(0, 8);
		});
	}

	
	
	/**
	 * Manipula o cookie do carrinho para permitir cálculo de frete
	 * sem alterar o carrinho real do usuário
	 */
	function handleCartCookie() {
	  cartCookie = getCookie("cart");
	  const tempCookieValue = "temp-cart-cookie___" + Date.now();
	  const fakeCookieValue = "fake-cart-cookie___" + Date.now();
	  
	  if (!cartCookie) {
		log("Nenhum cookie de carrinho encontrado");
		updateCartCookie(tempCookieValue);
		cartCookie = getCookie("cart");
	  } else {
		log("Cookie de carrinho encontrado");
	  }
	  
	  if (cartCookie.length < 32) {
		log("ID do carrinho não é válido");
		return false;
	  }
	  
	  updateCartCookie(fakeCookieValue);
	  log(getCookie("cart"));
	  
	  return true;
	}
	
	/**
	 * Calcula as taxas de frete para o produto e CEP informados
	 */
	function calculateShippingRates(variantId, productPrice) {
	  if (typeof variantId === "undefined" || !variantId) {
		resetUI();
		return;
	  }
	  
	  // Obter elementos UI
	  const shippingZip = document.querySelector("#shipping-calculator-input");
	  const shippingCalcButton = document.querySelector(".shippingCalcButton");
	  const shippingMessage = document.querySelector(".shipping-calc-wrapper .message");
	  
	  // Obter quantidade do produto
	  const productQuantity = document.querySelector(".quantity__input");
	  const quantity = productQuantity ? parseInt(productQuantity.value) : 1;
	  
	  // Dados para adicionar ao carrinho temporário
	  const addData = {
		id: variantId,
		quantity: quantity
	  };
	  
	  // Adicionar ao carrinho temporário e calcular frete
	  fetch("/cart/add.js", {
		body: JSON.stringify(addData),
		credentials: "same-origin",
		headers: {
		  "Content-Type": "application/json",
		  "X-Requested-With": "xmlhttprequest"
		},
		method: "POST"
	  })
	  .then(response => response.json())
	  .then(json => {
		// Buscar taxas de frete
		const params = new URLSearchParams({
		  "shipping_address[country]": shippingCountry.value,
		  "shipping_address[province]": shippingProvince.value,
		  "shipping_address[zip]": shippingZip.value
		});
		
		return fetch("/cart/shipping_rates.json?" + params);
	  })
	  .then(response => response.json())
	  .then(result => {
		// Processar resultados
		processShippingRates(result);
	  })
	  .catch(error => {
		console.error("Erro ao calcular o frete:", error);
		shippingMessage.className = "message error";
		shippingMessage.innerHTML = "Ocorreu um erro ao calcular o frete. Por favor, tente novamente.";
	  })
	  .finally(() => {
		// Restaurar UI e cookie original
		resetCartCookie();
		shippingCalcButton.toggleAttribute("loading", false);
		shippingCalcButton.removeAttribute("disabled");
	  });
	}
	
	/**
	 * Processa e exibe os resultados de taxas de frete
	 */
	function processShippingRates(result) {
	  const shippingMessage = document.querySelector(".shipping-calc-wrapper .message");
	  
	  // Verificar se existem resultados
	  if (result.shipping_rates && result.shipping_rates.length) {
		let messageHtml = "<ul>";
		
		// Processar cada opção de frete
		result.shipping_rates
		  .filter(e => !e.name?.includes("Stanley")) // Excluir certas transportadoras, se necessário
		  .forEach((element) => {
			// Formatar prazo de entrega
			let deliveryDays = "";
			if (element.delivery_days && element.delivery_days.length > 0) {
			  if (element.delivery_days[0] == 1) {
				deliveryDays = "<span>1 dia útil</span>";
			  } else {
				deliveryDays = `<span>${element.delivery_days[0]} dias úteis</span>`;
			  }
			}
			
			// Exibir opção de frete com preço
			const finalMessage = `${element.name} por R$ ${element.price.replace(".", ",")}`;
			
			messageHtml += `
			  <li>
				${finalMessage}
				<br>
				${deliveryDays || ""}
			  </li>
			`;
		  });
		
		messageHtml += "</ul>";
		shippingMessage.innerHTML = messageHtml;
	  } else {
		// Nenhum resultado encontrado
		shippingMessage.className = "message error";
		shippingMessage.innerHTML = window.shippingCalculator?.shippingEstimatorMessageError || 
		  "Não foi possível encontrar opções de frete para este CEP. Verifique o CEP e tente novamente.";
	  }
	}
	
	/**
	 * Resetar a UI para o estado inicial
	 */
	function resetUI() {
	  const shippingCalcButton = document.querySelector(".shippingCalcButton");
	  const shippingMessage = document.querySelector(".shipping-calc-wrapper .message");
	  
	  shippingMessage.innerHTML = "";
	  shippingCalcButton.toggleAttribute("loading", false);
	  shippingCalcButton.removeAttribute("disabled");
	}
	
	/**
	 * Funções utilitárias para manipulação de cookies
	 */
	function getCookie(name) {
	  const value = "; " + document.cookie;
	  const parts = value.split("; " + name + "=");
	  if (parts.length == 2) {
		return parts.pop().split(";").shift();
	  }
	}
	
	function updateCartCookie(value) {
	  log("Alterando o valor do cookie do carrinho para: " + value);
	  const date = new Date();
	  date.setTime(date.getTime() + (14 * 24 * 60 * 60 * 1000)); // 14 dias
	  const expires = "; expires=" + date.toGMTString();
	  document.cookie = "cart=" + value + expires + "; path=/";
	}
	
	function resetCartCookie() {
	  if (cartCookie) {
		updateCartCookie(cartCookie);
		log("Cookie do carrinho restaurado");
	  }
	}
	
	/**
	 * Função de log para depuração
	 */
	function log(message) {
	  if (DEBUG) {
		console.log(`[ShippingCalc] ${message}`);
	  }
	}
})();